module.exports = __webpack_public_path__ + "static/media/logo.007c7295.png";